__webpack_require__.p = "/mfe/configuration?file=";